import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import Search from '../../records/SeasonSearch';
import Smartcard from '../../records/customer/Smartcard';

import SeasonStartSummary from './SeasonStartSummary';
import SeasonCustomSummary from './SeasonCustomSummary';

class SeasonTicketCompact extends React.PureComponent {

    static propTypes = {
        search: PropTypes.instanceOf(Search).isRequired,
        onChange: PropTypes.func.isRequired,
        smartcard: PropTypes.instanceOf(Smartcard),
        error: PropTypes.string
    };

    static defaultProps = {
        smartcard: null,
        error: ''
    };

    render () {

        const { search, error, onChange, smartcard } = this.props;

        const classNames = classnames('btn-box-group', { 'season-start--error': error });

        return (
            <div className="datetime__summary-compact">
                <div className="datetime__summary margin-bottom--sm">
                    <div className={ classNames }>
                        <SeasonStartSummary
                            search={ search }
                            onChange={ onChange }
                            smartcard={ smartcard }
                            error={ error } />
                        { search.custom && <SeasonCustomSummary
                            search={ search }
                            onChange={ onChange } />
                        }
                    </div>
                </div>
            </div>
        );
    }

}

export default SeasonTicketCompact;



// WEBPACK FOOTER //
// ./src/components/seasonTicket/SeasonTicketCompact.js